<div class="modal fade" id="filtersModal" tabindex="-1" role="dialog" aria-labelledby="filtersModal" aria-hidden="true">
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<button
					type="button"
					class="btn-close"
					(click)="filtersClose()"
					data-bs-dismiss="modal"
					aria-label="Close"
				></button>
			</div>
			<div class="modal-body">
				<div class="mb-3">
					<div class="form-floating col mb-3">
						<input
							type="text"
							class="form-control"
							name="search"
							[(ngModel)]="filters.search"
							id="search"
						/>
						<label for="search" class="form-label">Nazwa wydarzenia</label>
					</div>
					<mat-radio-group
						class="d-flex flex-row gap-2 mt-3 mb-3"
						[(ngModel)]="filters.selectedFilterCustomerKind"
					>
						<mat-radio-button (change)="changeSelectedData(true)" [value]="customerType.PRIVATE"
							>Klient indywidualny
						</mat-radio-button>
						<mat-radio-button (change)="changeSelectedData(false)" [value]="customerType.COMPANY"
							>Firma
						</mat-radio-button>
					</mat-radio-group>
					<ng-container *ngIf="filters.selectedFilterCustomerKind === customerType.PRIVATE">
						<ng-select
							id="client"
							name="client"
							[(ngModel)]="filters.client"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of profile" [value]="item.id"
								>{{ item.firstName }} {{ item.lastName }} | {{ item.birth }} |
								{{ item.userContacts[0]?.phone }}
							</ng-option>
						</ng-select>
					</ng-container>
					<ng-container *ngIf="filters.selectedFilterCustomerKind === customerType.COMPANY">
						<ng-select
							id="company"
							name="company"
							[items]="organization"
							bindValue="id"
							bindLabel="shortName"
							[(ngModel)]="filters.company"
							[multiple]="true"
							[closeOnSelect]="false"
						>
						</ng-select>
					</ng-container>
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="date_from"
									[(ngModel)]="filters.date_from"
									id="date_from"
								/>
								<label for="date_from" class="form-label">Wpłaty od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="date_to"
									[(ngModel)]="filters.date_to"
									id="date_to"
								/>
								<label for="date_to" class="form-label">Wpłaty do</label>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="btn-group me-auto">
							<button type="button" class="btn btn-danger" (click)="filtersClear()">Wyczyść</button>
						</div>
						<div class="btn-group">
							<button type="button" class="btn btn-primary" (click)="filtersSave()">Pokaż</button>
							<button type="button" class="btn btn-secondary" (click)="filtersClose(); filtersDefault()">
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
